"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = void 0;
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
const create = config => {
  const {
    debug
  } = config;
  const log = options => {
    const {
      level,
      message
    } = options;
    if (debug || level === 'error') {
      console[level](message); // eslint-disable-line no-console
    }
  };
  const fn = level => message => log({
    level,
    message
  });
  const info = fn('info');
  const warn = fn('warn');
  const error = fn('error');
  return {
    log,
    info,
    warn,
    error
  };
};
exports.create = create;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(create, "create", "/Users/jake.clayton/frontend/ls-common-client/src/logger.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();